import HomeLayout from './HomeLayoutContainer';

export { HomeLayout };



// WEBPACK FOOTER //
// ./src/modules/home/HomeLayout/index.js